import React, { forwardRef } from 'react';

import MUIFormGroup, {
  FormGroupProps as MUIFormGroupProps,
} from '@material-ui/core/FormGroup';

interface FormGroupProps extends MUIFormGroupProps {}

const FormGroup = forwardRef<HTMLDivElement, FormGroupProps>((props, ref) => {
  return <MUIFormGroup {...props} ref={ref} />;
});

FormGroup.displayName = 'FormGroup';

export default FormGroup;
